import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/menu-toggle.svg'


const _withScopeId = n => (_pushScopeId("data-v-46839ca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "sticky-wrapper-sticky-wrapper",
  class: "sticky-wrapper",
  style: {"height":"70px"}
}
const _hoisted_2 = { id: "sticky-wrapper fixed-top" }
const _hoisted_3 = {
  id: "navaccordion",
  class: "container accordion"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3 mobile-toggler-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "toplogo",
  alt: "dark proxyscrape logo",
  src: "https://cdn.proxyscrape.com/img/logo/dark_text_logo.png"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#mainmenu",
  "aria-controls": "mainmenu",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "",
      src: _imports_0,
      style: {"width":"100%","height":"100%"}
    })
  ])
], -1))
const _hoisted_8 = { class: "col-md-9 navigation-container" }
const _hoisted_9 = { class: "navigation navbar-expand" }
const _hoisted_10 = {
  id: "mainmenu",
  class: "list-inline text-right collapse navbar-collapse"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_12 = { class: "dropdown current-menu-has-children" }
const _hoisted_13 = {
  "data-toggle": "collapse",
  "data-target": "#servicesM",
  "aria-controls": "servicesM",
  "aria-expanded": "false",
  "aria-label": "Toggle extra navigation",
  class: "collapsed"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Services ")
const _hoisted_15 = {
  class: "collapse",
  id: "servicesM"
}
const _hoisted_16 = { class: "dropdown-nav dropdown-nav-left" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Premium")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Residential")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Dedicated")
const _hoisted_20 = { class: "dropdown current-menu-has-children" }
const _hoisted_21 = {
  "data-toggle": "collapse",
  "data-target": "#freebiesM",
  "aria-controls": "freebiesM",
  "aria-expanded": "false",
  class: "collapsed",
  "aria-label": "Toggle extra navigation"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Freebies ")
const _hoisted_23 = {
  class: "collapse",
  "data-parent": "#navaccordion",
  id: "freebiesM"
}
const _hoisted_24 = { class: "dropdown-nav dropdown-nav-left" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Free proxy list")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Web proxy")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Online proxy checker ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Proxy filter")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.proxyscrape.com/",
    target: "_blank"
  }, " API ")
], -1))
const _hoisted_30 = { class: "dropdown current-menu-has-children" }
const _hoisted_31 = {
  "aria-controls": "helpmenu",
  "aria-expanded": "false",
  "aria-label": "Toggle help navigation",
  class: "collapsed",
  "data-target": "#helpmenu",
  "data-toggle": "collapse"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("help center ")
const _hoisted_33 = {
  id: "helpmenu",
  class: "collapse",
  "data-parent": "#navaccordion"
}
const _hoisted_34 = { class: "dropdown-nav dropdown-nav-left" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Visit help center")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://support.proxyscrape.com/" }, "Knowledge base")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://roadmap.proxyscrape.com/" }, "Roadmap")
], -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/blog/" }, "Blog")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://dashboard.proxyscrape.com/login" }, "Login")
], -1))

import { BIconCaretDownFill } from 'bootstrap-icons-vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* eslint-disable max-len */
/* eslint-disable max-len */


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                id: "logoheadurl",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_unref(BIconCaretDownFill))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("ul", _hoisted_16, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/premium" }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/residential" }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/dedicated" }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_unref(BIconCaretDownFill))
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("ul", _hoisted_24, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/free-proxy-list" }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/web-proxy" }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/online-proxy-checker" }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/proxy-filter" }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_29
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_30, [
                    _createElementVNode("a", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_unref(BIconCaretDownFill))
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("ul", _hoisted_34, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/help-center" }, {
                            default: _withCtx(() => [
                              _hoisted_35
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_36,
                        _hoisted_37,
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/contact" }, {
                            default: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_39,
                  _hoisted_40
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})